import { z } from "zod";
import { MiDetailFields, MiModal } from "@miplatform/components";
import {
  BUTTON_COLORS,
  BUTTON_VARIANTS,
  ENTITY_NAMES,
} from "@miplatform/constants";
import { useEdit } from "@miplatform/hooks";

const initialData = {
  name: "",
};

export const AddUpdateBuildTemplateModal = ({
  onModalClose,
  onSubmit,
  selectedData = initialData,
  loading,
  open,
}) => {
  const templateFields = [
    {
      label: `${ENTITY_NAMES.BUILD_TEMPLATE} Name`,
      name: "name",
      width: "100%",
      validationRule: z
        .string()
        .min(1, `${ENTITY_NAMES.BUILD_TEMPLATE} name is required.`),
    },
  ];
  const edit = useEdit(selectedData, templateFields);
  const handleModalClose = () => {
    onModalClose();
    edit.reset();
  };

  return (
    <MiModal
      open={open}
      closeModal={handleModalClose}
      actions={[
        {
          name: "Cancel",
          variant: BUTTON_VARIANTS.TEXT,
          size: "medium",
          color: BUTTON_COLORS.BLACK,
          onClick: handleModalClose,
        },
        {
          name: "Submit",
          variant: BUTTON_VARIANTS.CONTAINED,
          size: "medium",
          color: BUTTON_COLORS.PRIMARY,
          onClick: () => {
            onSubmit(edit.edits);
            edit.reset();
          },
          disabled: !edit.isDirty() || !edit.isValid(),
        },
      ]}
      loading={loading}
      title={`Add ${ENTITY_NAMES.BUILD_TEMPLATE}`}
      topRightClose={edit.reset}
    >
      <MiDetailFields detailFields={templateFields} edit={edit} />
    </MiModal>
  );
};
